import React from "react"


type CheckboxProps = {
    value: boolean;
    onChange: (value: boolean) => void;
    title: string;
    description?: string;
}

export function Checkbox({
    value,
    onChange,
    title,
    description,
                         }: CheckboxProps): JSX.Element {
    return (
        <div className="border border-light-light-grey rounded p-4">
            <label className="flex items-center gap-3 cursor-pointer">
                <input
                    type="checkbox"
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                    className="w-4 h-4 accent-blue"
                />
                <span className="font-medium">{title}</span>
            </label>
            {description && (<p className="text-sm text-grey mt-2 ml-7">
                {description}
            </p>)}
        </div>
    )
}